import React, { useCallback } from 'react';

import {
  serializeWhatsNewCarouselPayload,
  whatsNewCarouselPayloadDownloadFilename,
} from '~/utils/societePayloadBuilder/whatsNewCarousel/buildPayload';
import type { WhatsNewCarouselPayloadBuilderState } from '~/utils/societePayloadBuilder/whatsNewCarousel/types';

import PayloadBuilderJsonActions from '../JsonActions';

interface WhatsNewCarouselPayloadActionsProps {
  state: WhatsNewCarouselPayloadBuilderState;
  isValid: boolean;
  fullWidth?: boolean;
}

function getWhatsNewCarouselPayloadFilename() {
  return whatsNewCarouselPayloadDownloadFilename();
}

export default function WhatsNewCarouselPayloadActions({
  state,
  isValid,
  fullWidth = false,
}: WhatsNewCarouselPayloadActionsProps) {
  const isWhatsNewCarouselPayloadValid = useCallback(() => isValid, [isValid]);

  return (
    <PayloadBuilderJsonActions
      state={state}
      fullWidth={fullWidth}
      isValid={isWhatsNewCarouselPayloadValid}
      serialize={serializeWhatsNewCarouselPayload}
      getFilename={getWhatsNewCarouselPayloadFilename}
      disabledTitle="Fix validation errors before copying or downloading"
      copyLabel="Copy JSON"
      copySuccessMessage="What's New Carousel payload copied to clipboard"
      copyErrorMessage="Failed to copy What's New Carousel payload"
    />
  );
}
